import { render, staticRenderFns } from "./recommended-goods.vue?vue&type=template&id=4c9fe192&scoped=true&lang=pug&"
import script from "./recommended-goods.vue?vue&type=script&lang=js&"
export * from "./recommended-goods.vue?vue&type=script&lang=js&"
import style0 from "./recommended-goods.vue?vue&type=style&index=0&id=4c9fe192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9fe192",
  null
  
)

export default component.exports